'use client';

import { type FormControlProps } from '@ironhack/design-system2/components/form-control';
import { FormField } from '@ironhack/design-system2/components/form-field';
import { Textarea } from '@ironhack/design-system2/components/textarea';
import { type ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';

type Props = {
  label: string;
  error?: string;
  name: string;
  placeholder: string;
  isRequired: boolean;
} & FormControlProps;

export const TextareaField = (props: Props): ReactElement => {
  const { label, error, name, placeholder, isRequired, ...formFieldProps } =
    props;
  const { register } = useFormContext();

  return (
    <FormField
      error={error ?? ''}
      isInvalid={Boolean(error)}
      isRequired={isRequired}
      label={label}
      name={name}
      {...formFieldProps}
    >
      <Textarea
        placeholder={placeholder}
        {...register(name, { required: isRequired })}
      />
    </FormField>
  );
};
